/*
 * Fila de tarjetas por Año del DO, clickables para abrir el drill-down
 */
import { Box, Description, Flexbox, Stack, Title } from "codekit";

import { carteraPalette, fmtCOP } from "./utils/carthelp";

/**
 * Renderiza las tarjetas de valor pendiente por año
 * @param {Object} props Propiedades del componente
 * @param {Array} props.years Lista [{ year, valor, count }]
 * @param {Function} props.onYearClick Callback con el año al hacer click
 */
const Yearcard = ({ years = [], onYearClick }) => (
  <Flexbox gap={4} wrap>
    {years.map((mItem, nIndex) => {
      const sColor = carteraPalette[nIndex % carteraPalette.length];
      return (
        <Box
          key={mItem.year}
          bg="neutral-100"
          rounded="lg"
          border={1}
          borderColor="neutral-300"
          spacing={4}
          onClick={() => onYearClick(mItem.year)}
          style={{ flex: 1, minWidth: 130, textAlign: "center", cursor: "pointer" }}
        >
          <Stack gap={1}>
            <Title variant="title-3" color={sColor}>
              {mItem.year}
            </Title>
            <Title variant="title-2" color="secondary-800">
              {fmtCOP(mItem.valor)}
            </Title>
            <Description variant="description-3" color="neutral-500">
              {mItem.count} DO · Ver detalle ›
            </Description>
          </Stack>
        </Box>
      );
    })}
  </Flexbox>
);

export default Yearcard;
